import React from 'react';
import { Row, Col, Form, Modal, Radio, Button, Input } from 'antd';
import SpanComponent from '@sharedComponent/span-component';

const AddBankAccountModal = ({ state, formRef, onFinish, handleChange, routingValidate, accountValidate, handleAddBankChange, handleBankChange }) => {
	return (
		<Col>
			{/* Modal : Add Bank */}
			<Modal
				visible={state.activeModal}
				title={'Add New Bank Account'}
				centered={true}
				footer={null}
				closable={true}
				style={{ minWidth: '50%' }}
				onCancel={() => handleChange('activeModal', false)}
				destroyOnClose={true}
				className="bank_account_modal">
				<Form hideRequiredMark={true} style={{ width: '100%' }} layout="vertical" form={formRef} onFinish={onFinish}>
					<Row style={{ padding: '10px' }}>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item
								name="bankName"
								label="Bank Name"
								rules={[
									{
										required: true,
										message: 'Bank Name is required',
									},
								]}>
								<Input onInput={(e) => handleAddBankChange('bankName', e.target.value)} />
							</Form.Item>
						</Col>
						<Col xl={1} lg={1} md={0} sm={0} xs={0}></Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item
								name="accountNickName"
								label="Account Nickname"
								rules={[
									{
										required: true,
										message: 'Account NickName is required',
									},
								]}>
								<Input onInput={(e) => handleAddBankChange('accountNickName', e.target.value)} />
							</Form.Item>
						</Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item name="routingNumber" label="Routing Number">
								<Input.Password
									type="number"
									onInput={(e) => {
										routingValidate('isRoutingValid', e.target.value);
										handleAddBankChange('routingNumber', e.target.value);
									}}
								/>
								{!state.isRoutingValid ? (
									<SpanComponent className="error_msg"> Please enter a valid Routing Number</SpanComponent>
								) : null}
							</Form.Item>
						</Col>
						<Col xl={1} lg={1} md={0} sm={0} xs={0}></Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item name="confirmRoutingNumber" label="Confirm Routing Number">
								<Input.Password
									type="number"
									onInput={(e) => {
										routingValidate('isConfirmRoutingValid', e.target.value);
										handleBankChange('confirmRoutingNumber', e.target.value);
									}}
								/>
								{!state.isConfirmRoutingValid ? (
									<SpanComponent className="error_msg"> Please enter a valid Confirm Routing Number</SpanComponent>
								) : null}
							</Form.Item>
						</Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item name="accountNumber" label="Account Number">
								<Input.Password
									type="number"
									onInput={(e) => {
										accountValidate('isAccountValid', e.target.value);
										handleAddBankChange('accountNumber', e.target.value);
									}}
								/>
								{!state.isAccountValid ? (
									<SpanComponent className="error_msg"> Please enter a valid account Number</SpanComponent>
								) : null}
							</Form.Item>
						</Col>
						<Col xl={1} lg={1} md={0} sm={0} xs={0}></Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item name="confirmAccountNumber" label="Confirm Account Number">
								<Input.Password
									type="number"
									onInput={(e) => {
										accountValidate('isConfirmAccountValid', e.target.value);
										handleAddBankChange('confirmAccountNumber', e.target.value);
									}}
								/>
								{!state.isConfirmAccountValid ? (
									<SpanComponent className="error_msg"> Please enter a valid confirm account Number</SpanComponent>
								) : null}
							</Form.Item>
						</Col>
						<Col xl={1} lg={1} md={0} sm={0} xs={0}></Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}>
							<Form.Item
								label="Account Type"
								name="accountType"
								rules={[
									{
										required: true,
										message: 'Account Type is required',
									},
								]}>
								<Radio.Group onChange={(e) => handleAddBankChange('accountType', e.target.value)}>
									<Radio value={'Checking'}>Checking</Radio>
									<Radio value={'Savings'}>Savings</Radio>
								</Radio.Group>
							</Form.Item>
						</Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24}></Col>
						<Col xl={24} lg={24} md={24} sm={24} xs={24}>
							<Row>
								<Col xl={8} lg={8} md={24} sm={24} xs={24}></Col>
								<Col xl={8} lg={8} md={24} sm={24} xs={24}>
									<Button className="create_btn" loading={state.addbankLoading} htmlType="submit">
										Add Bank
									</Button>
								</Col>
								<Col xl={8} lg={8} md={24} sm={24} xs={24}></Col>
							</Row>
						</Col>
					</Row>
				</Form>
			</Modal>
		</Col>
	);
};
export default AddBankAccountModal;
